// ============================================================================
// Navigation configuration — drives the top navbar mega menus and the
// mobile expandable menu. Each top-level item may have a "menu" made up of
// one or more columns of links.
// ============================================================================

export const NAV_CONFIG = [
  {
    label: "Home",
    to: "/",
  },
  {
    label: "Product",
    to: "/product",
    // menu: {
    //   columns: [
    //     {
    //       heading: "Product",
    //       items: [
    //         {
    //           label: "Product Overview",
    //           to: "/product",
    //           description: "How MPeoples HRMS connects attendance, leave, payroll and admin.",
    //           icon: "product",
    //         },
    //         {
    //           label: "Application Modules",
    //           to: "/product/modules",
    //           description: "All 17 modules, from login to the Admin Dashboard.",
    //           icon: "modules",
    //         },
    //       ],
    //     },
    //   ],
    // },
  },
  // {
  //   label: "Solutions",
  //   to: "/solutions",
  //   menu: {
  //     columns: [
  //       {
  //         heading: "By workflow",
  //         items: [
  //           { label: "Attendance & Verification", to: "/solutions/attendance", description: "Selfie + GPS-verified check-in/out.", icon: "attendance" },
  //           { label: "Leave & Permission", to: "/solutions/leave-permission", description: "Requests, approvals and conversion policy.", icon: "leave" },
  //           { label: "Payroll & Deductions", to: "/solutions/payroll", description: "Automated late-minute deduction rules.", icon: "payroll" },
  //           { label: "Multi-Branch Management", to: "/solutions/multi-branch", description: "One system across every location.", icon: "branch" },
  //           { label: "Admin Dashboard", to: "/solutions/admin-dashboard", description: "Central console for HR and management.", icon: "dashboard" },
  //         ],
  //       },
  //     ],
  //   },
  // },
  {
    label: "Features",
    to: "/features",
    // menu: {
    //   columns: [
    //     {
    //       heading: "Features",
    //       items: [
    //         { label: "Feature Highlights", to: "/features", description: "Selfie verification, GPS, tickets, payroll and more.", icon: "features" },
    //         { label: "How It Works", to: "/features/how-it-works", description: "The employee and admin workflow, step by step.", icon: "workflow" },
    //       ],
    //     },
    //   ],
    // },
  },
  {
    label: "Benefits",
    to: "/benefits",
    menu: {
      columns: [
        {
          heading: "Benefits",
          items: [
            {
              label: "Employee & HR Benefits",
              to: "/benefits",
              description: "What moving onto MPeoples HRMS changes day to day.",
              icon: "benefits",
            },
            {
              label: "Business Impact",
              to: "/benefits/impact",
              description:
                "Transparency, efficiency, reliability and security.",
              icon: "impact",
            },
          ],
        },
      ],
    },
  },
  // {
  //   label: "Resources",
  //   to: "/resources",
  //   menu: {
  //     columns: [
  //       {
  //         heading: "Documentation",
  //         items: [
  //           {
  //             label: "API Documentation",
  //             to: "/resources/api-documentation",
  //             description: "REST endpoints for every module.",
  //             icon: "docs",
  //           },
  //           {
  //             label: "Permissions & Security",
  //             to: "/resources/security",
  //             description: "Auth, tokens and role-based access.",
  //             icon: "security",
  //           },
  //           {
  //             label: "Testing Overview",
  //             to: "/resources/testing",
  //             description: "Functional, UI, API and device testing.",
  //             icon: "testing",
  //           },
  //           {
  //             label: "Deployment",
  //             to: "/resources/deployment",
  //             description: "Play Console distribution and HTTPS setup.",
  //             icon: "deployment",
  //           },
  //           {
  //             label: "Troubleshooting",
  //             to: "/resources/troubleshooting",
  //             description: "Fixes for common login and sync issues.",
  //             icon: "troubleshooting",
  //           },
  //         ],
  //       },
  //     ],
  //   },
  // },
  {
    label: "About",
    to: "/about",
  },
];
